
import { CodebookModel, PermissionTypeEnum, TenantModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthAction, AuthGetter } from '@/libs/auth/models/auth-state';
import { codebooksStore } from '@/libs/codebooks/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { tenantsStore } from '@/libs/tenants/+state/store';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import Page from '@/Page.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({})
export default class Home extends Page {
    getDataList(): Array<any> {
        const tenantId = authStore.useGetter(AuthGetter.GetTenant);
        const useTpm = (window as any).UseTpm;
        if (tenantId && tenantId.length > 0) {
            const onlyDashboard = authStore.useGetter(AuthGetter.GetOnlyDashboard);
            const onlyDashboardAndCalendar = authStore.useGetter(AuthGetter.GetOnlyDashboardAndCalendar);
            const disableDashboard = authStore.useGetter(AuthGetter.GetDisableDashboard);
            if (onlyDashboardAndCalendar) {
                return [
                    {
                        text: this.$i18n.t('menu.dashboard'),
                        to: { name: 'Dashboard', params: { tenantId: tenantId } },
                        icon: 'dashboard.svg',
                    },
                    {
                        text: this.$i18n.t('menu.tasks'),
                        to: { name: 'WorkTasks', params: { tenantId: tenantId } },
                        icon: 'calendar.svg',
                        permissions: [PermissionTypeEnum.Response, PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Plan],
                    },
                ].filter((x) => this.hasPermissions(x.permissions ?? []) || !x.permissions || x.permissions.length == 0);
            } else if (onlyDashboard) {
                return [
                    {
                        text: this.$i18n.t('menu.dashboard'),
                        to: { name: 'Dashboard', params: { tenantId: tenantId } },
                        icon: 'dashboard.svg',
                    },
                ];
            }
            let items: {
                text: any;
                to: any;
                icon: any;
                permissions?: Array<PermissionTypeEnum>;
            }[] = !disableDashboard
                ? [
                      {
                          text: this.$i18n.t('menu.dashboard'),
                          to: { name: 'Dashboard', params: { tenantId: tenantId } },
                          icon: 'dashboard.svg',
                      },
                  ]
                : [];
            items = [
                ...items,
                ...[
                    {
                        text: this.$i18n.t('menu.audit'),
                        to: { name: 'Audits', params: { tenantId: tenantId } },
                        icon: 'audits.svg',
                        permissions: [
                            PermissionTypeEnum.Audits,
                            PermissionTypeEnum.EditAllAudits,
                            PermissionTypeEnum.EditOwnedAudit,
                            PermissionTypeEnum.PerformAudit,
                        ],
                    },
                ],
            ];
            if (useTpm) {
                items = [
                    ...items,
                    ...[
                        {
                            text: this.$i18n.t('menu.shiftWork'),
                            to: { name: 'ShiftWork', params: { tenantId: tenantId } },
                            icon: 'shiftWork.svg',
                            permissions: [PermissionTypeEnum.ShiftManagement],
                        },
                        {
                            text: this.$i18n.t('menu.shifts'),
                            to: { name: 'Shifts', params: { tenantId: tenantId } },
                            icon: 'shifts.svg',
                            permissions: [PermissionTypeEnum.ShiftManagement],
                        },
                        {
                            text: this.$i18n.t('menu.shiftStations'),
                            to: { name: 'ShiftStations', params: { tenantId: tenantId } },
                            icon: 'shiftStations.svg',
                            permissions: [PermissionTypeEnum.ShiftManagement],
                        },
                        {
                            text: this.$i18n.t('menu.shiftWorkList'),
                            to: { name: 'ShiftWorkList', params: { tenantId: tenantId } },
                            icon: 'shiftWorks.svg',
                            permissions: [PermissionTypeEnum.ShiftWork, PermissionTypeEnum.ShiftWorkLimited],
                        },
                        {
                            text: this.$i18n.t('menu.shiftReport'),
                            to: { name: 'ShiftReport', params: { tenantId: tenantId } },
                            icon: 'shiftReport.svg',
                            permissions: [PermissionTypeEnum.ShiftOverview],
                        },
                    ],
                ];
            }
            items = [
                ...items,
                ...[
                    {
                        text: this.$i18n.t('menu.tasks'),
                        to: { name: 'WorkTasks', params: { tenantId: tenantId } },
                        icon: 'calendar.svg',
                        permissions: [PermissionTypeEnum.Response, PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Plan],
                    },
                ],
            ];
            if (useTpm) {
                items = [
                    ...items,
                    ...[
                        {
                            text: this.$i18n.t('menu.issuesSolving'),
                            to: { name: 'IssuesSolving', params: { tenantId: tenantId } },
                            icon: 'issuesSolving.svg',
                            permissions: [PermissionTypeEnum.ReportIssueSolving, PermissionTypeEnum.PerformAudit],
                        },
                    ],
                ];
            }
            items = [
                ...items,
                ...[
                    {
                        text: this.$i18n.t('menu.productInspection'),
                        to: { name: 'ProductInspections', params: { tenantId: tenantId } },
                        icon: 'productInspection.svg',
                        permissions: [PermissionTypeEnum.PerformProductInspection],
                    },
                    {
                        text: this.$i18n.t('menu.responses'),
                        to: { name: 'Responses', params: { tenantId: tenantId } },
                        icon: 'responses.svg',
                        permissions: [
                            PermissionTypeEnum.PerformAudit,
                            PermissionTypeEnum.Response,
                            PermissionTypeEnum.MistakeCorrection,
                        ],
                    },
                ],
            ];
            if (useTpm) {
                items = [
                    ...items,
                    ...[
                        {
                            text: this.$i18n.t('menu.reportedIssueSolving'),
                            to: { name: 'ReportedIssueSolving', params: { tenantId: tenantId } },
                            icon: 'reportedIssueSolving.svg',
                            permissions: [
                                PermissionTypeEnum.PerformAudit,
                                PermissionTypeEnum.Response,
                                PermissionTypeEnum.MistakeCorrection,
                            ],
                        },
                        {
                            text: this.$i18n.t('menu.reportedMaintenance'),
                            to: { name: 'ReportedMaintenance', params: { tenantId: tenantId } },
                            icon: 'reportedMaintenance.svg',
                            permissions: [
                                PermissionTypeEnum.PerformAudit,
                                PermissionTypeEnum.Response,
                                PermissionTypeEnum.MistakeCorrection,
                            ],
                        },
                        {
                            text: this.$i18n.t('menu.reportedChecklists'),
                            to: { name: 'ReportedChecklists', params: { tenantId: tenantId } },
                            icon: 'reportedChecklists.svg',
                            permissions: [
                                PermissionTypeEnum.PerformAudit,
                                PermissionTypeEnum.Response,
                                PermissionTypeEnum.MistakeCorrection,
                            ],
                        },
                    ],
                ];
            }
            items = [
                ...items,
                ...[
                    {
                        text: this.$i18n.t('menu.reportedProductInspection'),
                        to: { name: 'ReportedProductInspection', params: { tenantId: tenantId } },
                        icon: 'reportedProductInspection.svg',
                        permissions: [PermissionTypeEnum.ProductInspections, PermissionTypeEnum.MistakeCorrection],
                    },
                    {
                        text: this.$i18n.t('menu.unfinishedResponses'),
                        to: { name: 'Unanswered', params: { tenantId: tenantId } },
                        icon: 'unanswered-responses.svg',
                        permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response],
                    },
                ],
            ];
            if (useTpm) {
                items = [
                    ...items,
                    ...[
                        {
                            text: this.$i18n.t('menu.waitingMaintenance'),
                            to: { name: 'WaitingMaintenance', params: { tenantId: tenantId } },
                            icon: 'waitingMaintenance.svg',
                            permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response],
                        },
                    ],
                ];
            }
            items = [
                ...items,
                ...[
                    {
                        text: this.$i18n.t('menu.issues'),
                        to: { name: 'Issues', params: { tenantId: tenantId } },
                        icon: 'issues.svg',
                        permissions: [PermissionTypeEnum.Findings, PermissionTypeEnum.FindingManager],
                    },
                    {
                        text: this.$i18n.t('menu.findings'),
                        to: { name: 'Findings', params: { tenantId: tenantId } },
                        icon: 'findings.svg',
                        permissions: [PermissionTypeEnum.Findings, PermissionTypeEnum.FindingManager],
                    },
                    {
                        text: this.$i18n.t('menu.solvedIssues'),
                        to: { name: 'Measures', params: { tenantId: tenantId } },
                        icon: 'measure.svg',
                        permissions: [
                            PermissionTypeEnum.Measures,
                            PermissionTypeEnum.MeasuresAllUsers,
                            PermissionTypeEnum.MeasureView,
                        ],
                    },
                    {
                        text: this.$i18n.t('menu.verification'),
                        to: { name: 'Verification', params: { tenantId: tenantId } },
                        icon: 'resources.svg',
                        permissions: [PermissionTypeEnum.MeasureVerification, PermissionTypeEnum.MeasureView],
                    },
                    {
                        text: this.$i18n.t('menu.review'),
                        to: { name: 'Review', params: { tenantId: tenantId } },
                        icon: 'tasks.svg',
                        permissions: [PermissionTypeEnum.PlanItemReview],
                    },
                ],
            ];
            if (useTpm) {
                items = [
                    ...items,
                    ...[
                        {
                            text: this.$i18n.t('menu.panelDashboards'),
                            to: { name: 'PanelDashboards', params: { tenantId: tenantId } },
                            icon: 'panelDashboards.svg',
                            permissions: [PermissionTypeEnum.PanelDashboardEdit, PermissionTypeEnum.PanelDashboardView],
                        },
                    ],
                ];
            }
            items = [
                ...items,
                ...[
                    {
                        text: this.$i18n.t('menu.reports'),
                        to: { name: 'ReportByQuestion', params: { tenantId: tenantId } },
                        icon: 'reports.svg',
                        permissions: [
                            PermissionTypeEnum.Response,
                            PermissionTypeEnum.Audits,
                            PermissionTypeEnum.PerformProductInspection,
                        ],
                    },
                ],
            ];
            return items.filter((x) => this.hasPermissions(x.permissions ?? []) || !x.permissions || x.permissions.length == 0);
        } else {
            return [];
        }
    }

    mounted() {
        applicationUserStore.dispatch(CrudAction.Get, {});
        this.subscribe(applicationUserStore, CrudReponse.Get).then((e: any) => {
            tenantsStore.dispatch(
                CrudAction.GetAll,
                createCrudQueryPayload<TenantModel>({
                    field: 'name',
                    order: 'asc',
                })
            );
            this.subscribe(tenantsStore, CrudReponse.GetAll).then((e: TenantModel[]) => {
                if (e.length > 0) {
                    this.loadCodebooks().then(() => {
                        let tenantId = this.$route.params.tenantId;
                        if (
                            !tenantId &&
                            window.localStorage.CurrentTenant &&
                            e.any((x) => x.id == window.localStorage.CurrentTenant)
                        ) {
                            tenantId = window.localStorage.CurrentTenant;
                        } else if (tenantId == undefined && e.length > 0) {
                            tenantId = e[0].id!;
                        }
                        authStore.dispatch(AuthAction.SetTenant, tenantId);
                        const route = this.getFirstRoute(e[0].id!);
                        route.params.tenantId = tenantId;
                        this.$router.push(route ?? { name: 'UserSettings' });
                    });
                } else {
                    authStore.dispatch(AuthAction.SetTenant, '');
                    this.$router.push({ name: 'UserSettings' });
                }
            });
        });
    }

    loadCodebooks(): Promise<any> {
        return new Promise((resolve, reject) => {
            codebooksStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CodebookModel>());
            this.subscribe(codebooksStore, CrudReponse.GetAll)
                .then((e: CodebookModel[]) => {
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    getFirstRoute(tenantId: string | null): any {
        const routes = this.getDataList();
        for (const route of routes) {
            if (this.hasPermissions(route.permissions)) {
                return { name: route.to.name, params: { tenantId } };
            }
        }
        return null;
    }
}
